"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoanPurpose;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _Asset = _interopRequireDefault(require("../assets/Asset 1.jpg"));
var _Asset2 = _interopRequireDefault(require("../assets/Asset 2.jpg"));
var _Asset3 = _interopRequireDefault(require("../assets/Asset 3.jpg"));
var _usersession = require("usersession");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { useRatesContext } from "../context/ratesContext";

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop, {
  behavior: "smooth"
});
// General scroll to element function

function LoanPurpose() {
  // const {
  //   state,
  //   TypeSelected,
  //   ShowButtons,
  //   PurchasePriceUpdate,
  //   DownPaymentInUSDsUpdate,
  //   estimatedValueUpdate,
  //   loanBalanceUpdate,
  //   cashoutAmountUpdate,
  // } = useRatesContext();
  const [loanPurpose, setLoanPurpose] = (0, _react.useState)("");
  const dispatch = (0, _reactRedux.useDispatch)();
  const loanPurposeRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.type);
  // const loanPurposeRedux = state.type;
  const userSession = new _usersession.UserSession();
  const myRefLP = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    //This function scroll the slider into view
    !localStorage.getItem("doNotScroll") && scrollToRef(myRefLP);
  }, []);
  (0, _react.useEffect)(() => {
    /* Initialize the custom quote navigation as this is the first page.
    Many other elements on the page will depend on this flag to perform different actions.
        */
    dispatch((0, _actions.ShowButtons)(true));
    // ShowButtons(true);
    userSession.setCustomQuote(true);
    setLoanPurpose(loanPurposeRedux);
    userSession.setLoanPurpose(loanPurposeRedux);
    if (loanPurpose.length > 0) {
      dispatch((0, _actions.ShowButtons)(true));
      // ShowButtons(true);
      if (loanPurpose === "FULL DOCS REFI" || loanPurpose === "CASH OUT REFI") {
        dispatch((0, _actions.PurchasePriceUpdate)(0));
        dispatch((0, _actions.DownPaymentInUSDsUpdate)(0));
        // PurchasePriceUpdate(0);
        // DownPaymentInUSDsUpdate(0);
        userSession.setPurchasePrice(0);
        userSession.setDownPaymentAmount(0);
        userSession.setCashOutAmount(0); //This is only for the Refi case if the user selected cashout the value will be modify.
      }
      if (loanPurpose === "PURCHASE") {
        dispatch((0, _actions.estimatedValueUpdate)(0));
        // estimatedValueUpdate(0);
        dispatch((0, _actions.loanBalanceUpdate)(0));
        // loanBalanceUpdate(0);
        dispatch((0, _actions.cashoutAmountUpdate)(0));
        // cashoutAmountUpdate(0);
        userSession.setEstimatedValue(0);
        userSession.setCurrentLoanBalance(0);
        userSession.setCashOutAmount(0);
      }
    }
  }, [loanPurpose]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "mb-0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "pt-1 d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 10,
    sm: 10,
    md: 11,
    lg: 12,
    className: "text-center mb-3 pb-1"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "What loan purpose would you like to look into?")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12,
    lg: 1,
    className: "d-none d-sm-none d-md-none d-lg-flex align-items-center justify-content-center pb-2 pb-sm-2 pb-md-0 mb-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "backToHome",
    onClick: () => window.location.reload(false)
  }, "<<")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    ref: myRefLP,
    lg: 3,
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    type: "radio",
    inline: true,
    id: "loanPurchase",
    name: "loanPurchase",
    value: "PURCHASE",
    "aria-label": "Purchase",
    label: "Purchase",
    checked: loanPurpose === "PURCHASE",
    onChange: e => {
      setLoanPurpose(e.target.value);
      dispatch((0, _actions.TypeSelected)(e.target.value));
      // TypeSelected(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset.default,
    alt: "Purchase Home",
    className: "radImg2 rounded-circle radImg customShadow \n                            ".concat(loanPurpose === "PURCHASE" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Purchase")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 3,
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    type: "radio",
    id: "loanFullDocsRefi",
    name: "loanFullDocsRefi",
    inline: true,
    value: "FULL DOCS REFI",
    label: "Refi",
    "aria-label": "Refi",
    checked: loanPurpose === "FULL DOCS REFI",
    onChange: e => {
      setLoanPurpose(e.target.value);
      dispatch((0, _actions.TypeSelected)(e.target.value));
      // TypeSelected(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset2.default,
    alt: "Refinance Home",
    className: "radImg2 rounded-circle radImg customShadow ".concat(loanPurpose === "FULL DOCS REFI" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Refinance")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 3,
    className: "mb-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    type: "radio",
    inline: true,
    id: "loanCashOut",
    name: "loanCashOut",
    value: "CASH OUT REFI",
    "aria-label": "Cash Out Refi",
    label: "Cash Out Refi",
    checked: loanPurpose === "CASH OUT REFI",
    onChange: e => {
      setLoanPurpose(e.target.value);
      dispatch((0, _actions.TypeSelected)(e.target.value));
      // TypeSelected(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset3.default,
    alt: "Cash out Home",
    className: "radImg2 rounded-circle radImg customShadow ".concat(loanPurpose === "CASH OUT REFI" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Cash Out Refi")))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "d-inline d-sm-inline d-md-inline d-lg-none float-left backToHome",
    onClick: () => window.location.reload(false)
  }, "<<"));
}